import { Locale } from '@/common/model';
import { create } from 'zustand/react';

interface LocaleStore {
  locale: Locale;
  pageLocale: Locale;
  setLocale: (locale: Locale) => void;
  setPageLocale: (locale: Locale) => void;
}

export const useLocaleStore = create<LocaleStore>((setState) => {
  return {
    locale: 'en',
    pageLocale: 'en',
    setLocale: (locale: Locale) => {
      setState({ locale: locale, pageLocale: locale });
    },
    setPageLocale: (locale: Locale) => {
      setState({ pageLocale: locale });
    },
  };
});
